













import Vue from 'vue';
import { Actions } from '@/store';
import { TvOpportunity } from '@/models/kitchen-tv';
import Loader from '@/components/core/Loader.vue';
import { HeaderBoard } from '@/components/kitchen-tv';
import { OpportunityItem } from '@/components/kitchen-tv/card-items';

export default Vue.extend({
  name: 'Opportunities',
  components: {
    HeaderBoard,
    Loader,
    OpportunityItem,
  },
  data() {
    return {
      showComponent: false,
      loader: {
        isPending: false,
      },
    };
  },
  async created() {
    this.loader.isPending = true;
    try {
      await this.$store.dispatch(Actions.kitchenTv.fetchOpportunities);
    } finally {
      this.loader.isPending = false;
    }
    if (this.opportunities.length === 0) {
      this.$emit('skipSlide');
    } else {
      this.showComponent = true;
    }
  },
  computed: {
    opportunities(): TvOpportunity[] {
      return this.$store.state.kitchenTv.opportunities;
    },
  },
});
